module.exports = __webpack_public_path__ + "media/src/images/icons/linkedin_logo-c99809fe1ca98f812abfa06b64ab471b.svg";